import axiosInstance from './Instance/axiosInstance';
import { LoanRepayment } from '../types/loanRepayment';

export const getLoanRepayments = async (): Promise<LoanRepayment[]> => {
    const res = await axiosInstance.get('/loan-repayments');
    return res.data;
};

export const createLoanRepayment = async (data: Omit<LoanRepayment, 'id'>): Promise<LoanRepayment> => {
    const res = await axiosInstance.post('/loan-repayments', data);
    return res.data;
};

export const updateLoanRepayment = async (id: string, data: Omit<LoanRepayment, 'id'>): Promise<LoanRepayment> => {
    const res = await axiosInstance.put(`/loan-repayments/${id}`, data);
    return res.data;
};

export const deleteLoanRepayment = async (id: string): Promise<void> => {
    await axiosInstance.delete(`/loan-repayments/${id}`);
};
